import useOnce from "hooks/use-once";
import { useState } from "react";
import { displayError } from "../../../../../core/utils/modals";
import { buscarPagosDomiciliados as apiBuscarPagos } from "../../api/pagos.api";
import PagosDomiciliadosTable from "../../components/pagos-domiciliados.table";
import { PagoDomiciliadoRespuesta } from "../../types/pagos.types";

const usePagosDomiciliados = () => {
	const [registros, setRegistros] = useState<PagoDomiciliadoRespuesta[]>([]);

	const buscarPagos = () => {
		setRegistros([]);

		apiBuscarPagos()
			.then(setRegistros)
			.catch(displayError);
	};

	useOnce(() => {
		buscarPagos();
	});

	return {
		registros
	};
};

const PagosDomiciliadosView = () => {
	const {
		registros
	} = usePagosDomiciliados();

	return (
		<PagosDomiciliadosTable registros={registros} />
	);
};

export default PagosDomiciliadosView;